import { Colors } from "@auteco/theme";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
    textArea: {
        margin: '12px 0'
    },
    btnsContainer: {
        display: 'flex',
        justifyContent: 'center'
    },
    acceptBtn: {
        width: '120px'
    },
    cancelBtn: {
        width: '120px',
        border: `2px solid ${Colors.DARK_BLUE}`,
        background: '#fff',
        color: Colors.DARK_BLUE,
        marginRight: '12px',
        '&:hover': {
            background: 'white',
            color: Colors.DARK_BLUE
        }
    }
}))

export { useStyles }